import React, {Component, Fragment} from 'react';
import axios from 'axios';
import RoomListItem from "../../components/RoomListItem/RoomListItem";
import RoomListItemAdmin from "../../components/RoomListItemAdmin/RoomListItemAdmin";
import ListEditButtons from "../../components/ListEditButtons/ListEditButtons";
import {Link} from "react-router-dom";
import Ratings from 'react-ratings-declarative';


class HotelDetails extends Component {

    constructor(props) {
        super(props);
        document.title = 'Hotel details';
    }


    state = {
        userDetails: JSON.parse(localStorage.getItem("user")),
        rooms: [],
        reservations: [],
        hotel: {
            id: 0,
            name: '',
            address: '',
            imageUrl: '',
            description: '',
            averageRatings:''
        }
    };

    goBack = () => {
        this.props.history.goBack();
    };

    componentDidMount() {

        axios.get('/api/hotels/' + this.props.match.params.id)
            .then(response => {
                this.setState({
                    hotel: response.data
                });
            });

        this.getRooms();
    }

    getRooms = () => {
        axios.get('/api/hotels/' + this.props.match.params.id + '/rooms')
            .then(response => {
                this.setState({
                    rooms: response.data
                });
            });
        this.getReservation()
    };

    getReservation = () => {
        axios.get('/api/hotels/reservations/' + this.props.match.params.id)
            .then(response => {
                this.setState({
                    reservations: response.data
                });
            });

    };



    getReservation = () => {
        axios.get('/api/hotels/reservations/' + this.props.match.params.id)
            .then(response => {
                this.setState({
                    reservations: response.data
                });
            });

    }
    deleteRoomHandler = (id) => {
        axios.delete('/api/rooms/' + id)
            .then(response => {
                this.componentDidMount();
            })
            .catch(error => {
                console.warn(error.response);
            });
    }

    isValid = () => {
        let user = JSON.parse(localStorage.getItem('user'));
        console.log(user);
        return (user.role === "ROLE_ADMINISTRATOR");
    }

    reservationEdit = (id, guestName, startDate, endDate) => {

        const monthDayFormat = (number) => {
            return number > 9 ? "" + number : "0" + number;
        };
        const startDateRightFormat = startDate[0] + "-" + monthDayFormat(startDate[1]) + "-" + monthDayFormat(startDate[2]);
        const endDateRightFormat = endDate[0] + "-" + monthDayFormat(endDate[1]) + "-" + monthDayFormat(endDate[2]);


        this.setState({
            reservationId:id,
            reservationFormData: {
                guestName: {
                    value: guestName,
                    isValid: true,
                    message: ''
                },
                startDate: {
                    value: startDateRightFormat,
                    isValid: true,
                    message: ''
                },
                endDate: {
                    value: endDateRightFormat,
                    isValid: true,
                    message: ''
                },
                roomId: {
                    value: this.props.match.params.id,
                    isValid: true,
                    message: ''
                }
            }
        });

    };

    deleteReservationHandler = (id) => {
        console.log("deleteReservationHandler: ", "/api/rooms/" + this.props.match.params.id + "/reservations/" + id)
        axios.delete("/api/rooms/" + this.props.match.params.id + "/reservations/" + id)
            .then(response => {
                console.log(response);
                this.componentDidMount();
            })
            .catch(error => {
                console.warn(error.response);
            });
    };


    render() {
        let imgUrl;
        if (this.state.hotel.imageUrl === null || this.state.hotel.imageUrl.trim() === '') {
            imgUrl = '/images/noimage.png';
        } else {
            imgUrl = this.state.hotel.imageUrl;
        }




        const rooms = (this.isValid()) ? this.state.rooms.map(room => {
                return <RoomListItemAdmin
                    key={room.id}
                    id={room.id}
                    name={room.name}
                    imageUrl={room.imageUrl}
                    numberOfBeds={room.numberOfBeds}
                    pricePerNight={room.pricePerNight}
                    deleteHandler={this.deleteRoomHandler}
                    reservations={this.state.reservations}
                    reservationEdit={this.reservationEdit}
                />
            }) : this.state.rooms.map(room => {
                return <RoomListItem
                    key={room.id}
                    id={room.id}
                    name={room.name}
                    imageUrl={room.imageUrl}
                    numberOfBeds={room.numberOfBeds}
                    pricePerNight={room.pricePerNight}
                    deleteHandler={this.deleteRoomHandler}
                />
            })
        ;



        const bgStyle = {
            height: "70vh",
            backgroundImage: `url(${imgUrl})`,
            marginTop: "-20px",
            align: "center top"
        };

        const topMargin = {
            marginTop: '50px'
        };

        return (
            <Fragment>
                <div className="page-header header-filter" data-parallax="true"
                     style={bgStyle}>
                    <div className="container">
                        <div className="row">
                            <div className="card col-md-6" style={{
                                opacity: "0.9",
                            }}>
                                <h2 className="card-title" style={topMargin}>{this.state.hotel.name}</h2>
                                <h3 className="card-title">{this.state.hotel.address}</h3>
                                <hr/>
                                <h4>{this.state.hotel.description}</h4>
                                <Ratings
                                    rating={this.state.hotel.averageRatings/2}
                                    widgetDimensions="15px"
                                    widgetSpacings="2px"
                                >
                                    <Ratings.Widget widgetRatedColor="orange" />
                                    <Ratings.Widget widgetRatedColor="orange" />
                                    <Ratings.Widget widgetRatedColor="orange" />
                                    <Ratings.Widget widgetRatedColor="orange" />
                                    <Ratings.Widget widgetRatedColor="orange"/>
                                </Ratings>
                                <div>
                                <Link to={"/ratings/" + this.state.hotel.id}
                                      className="btn btn-sm"
                                >Show ratings</Link></div>
                                <br/>
                                <div>
                                    <ListEditButtons
                                        to={"/modify-hotel/" + this.state.hotel.id}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="main main-raised" style={topMargin}>
                    <div className="profile-content">
                        <div className="container">
                            <br/>
                            <h2>Rooms</h2>
                            <div className={this.isValid() ? "" : "row"}>
                                {rooms}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>

        )
    }
}

export default HotelDetails;



// WEBPACK FOOTER //
// ./src/containers/HotelDetails/HotelDetails.jsx